import { useRef, useState } from "react";

// L-gesture gate: kept behind LOGIN_MODE=gesture. Draw down, then right.
export const GestureLogin = ({ onSuccess }) => {
  const ref = useRef(null);
  const pts = useRef([]);
  const [hint, setHint] = useState("Ekranda bir “L” çiz: aşağı, sonra sağa.");

  const point = (e) => {
    const r = ref.current.getBoundingClientRect();
    return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
  };
  const start = (e) => {
    pts.current = [point(e)];
  };
  const move = (e) => {
    if (pts.current.length) pts.current.push(point(e));
  };
  const end = () => {
    const p = pts.current;
    pts.current = [];
    if (p.length < 8) return;
    const ys = p.map((q) => q.y);
    const turn = ys.indexOf(Math.max(...ys));
    const down = p[turn].y - p[0].y;
    const right = p[p.length - 1].x - p[turn].x;
    const drift = Math.abs(p[turn].x - p[0].x);
    if (down > 0.35 && right > 0.3 && drift < 0.2) onSuccess();
    else setHint("Tanınmadı. Önce dik aşağı, sonra sağa doğru çiz.");
  };

  return (
    <div className="w-full max-w-sm text-center" data-testid="gesture-login">
      <p className="eyebrow">Yönetim</p>
      <div
        ref={ref}
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        className="glass mt-4 aspect-square touch-none select-none"
        data-testid="gesture-canvas"
      />
      <p className="mt-4 text-sm text-slate-400" data-testid="gesture-hint">{hint}</p>
    </div>
  );
};
